import React from 'react'
import styles from './styles.css'
const {detect} = require('detect-browser')
const browser = detect()

export default class BrowseVersion extends React.Component {
  static propTypes = {}

  renderMessage() {
    return (
      <div className={styles.message}>
        <b style={{color: '#ff0000'}}>Advertencia</b>: Actualmente posees una versión desactualizada
        de tu navegador. Te recomendamos actualizalo para un funcionamiento óptimo.
      </div>
    )
  }

  edgeMessage() {
    return (
      <div className={styles.message}>
        <b style={{color: '#ff0000'}}>Advertencia</b>: Actualmente estas utilizando Microsoft Edge.
        Te recomendamos utilizar Firefox o Chrome para un mejor funcionamiento.
      </div>
    )
  }

  browseMessage() {
    if (browser) {
      if (browser.name === 'chrome') {
        if (parseInt(browser.version, 10) < 62) {
          return this.renderMessage()
        }
      }
      if (browser.name === 'firefox') {
        if (parseInt(browser.version, 10) < 58) {
          return this.renderMessage()
        }
      }
      if (browser.name === 'edge') {
        return this.edgeMessage()
      }
      if (browser.name === 'safari') {
        if (parseInt(browser.version, 10) < 11.1 && browser.version !== 'TP') {
          return this.renderMessage()
        }
      }
      return null
    }
  }

  render() {
    return <div className={styles.container}>{this.browseMessage()}</div>
  }
}



// WEBPACK FOOTER //
// ./src/App/Pages/Settings/Signature/BrowseVersion/index.js